/* eslint-disable */
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Sparkle, Search, X } from "lucide-react";
import DataTableTemplatingDemo from "./DataTableTemplatingAi";

const AiGeneratedProductsTable = ({ setLgShow, setData }) => {
  const { t, i18n } = useTranslation();

  const [filter, setFilter] = useState("");
  const [pageSize] = useState(12);
  const total = useSelector(
    (state) =>
      (state.ProductsReducer || []).filter(
        (p) =>
          p.deleted !== 1 && p.created_via === "FoorAiLandingPageGenerator",
      ).length,
  );

  return (
    <div
      className="bg-[#fbf8fd] dark:!bg-[#141414] rounded-xl"
      dir={i18n.language === "ar" ? "rtl" : "ltr"}
    >
      <div className="relative overflow-hidden flex flex-wrap items-center justify-between gap-4 p-5 bg-white dark:!bg-[#181919] rounded-t-xl border-b border-[#f0e6f6] dark:!border-[#3c3a3d]">
        <div className="pointer-events-none absolute -top-16 -end-10 w-56 h-56 rounded-full bg-[#9b59bf]/10 blur-3xl" />
        <div className="relative flex items-center gap-3">
          <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#9b59bf] to-[#7e5395] text-white flex items-center justify-center shadow-md shadow-purple-300/40 dark:shadow-none">
            <Sparkle size={20} />
          </div>
          <div>
            <div className="flex items-center gap-2">
              <h5 className="font-bold text-lg text-gray-900 dark:text-gray-100 m-0">
                {t(
                  "Products.Table.aiGenerated.title",
                  "المنتجات المُنشأة بالذكاء الاصطناعي",
                )}
              </h5>
              <span className="rounded-full bg-[#f3e8fa] dark:bg-[#2a2a2c] text-[#7e5395] dark:text-[#d2a8ec] text-xs font-bold px-2.5 py-0.5 tabular-nums">
                {total}
              </span>
            </div>
            <p className="text-sm text-gray-500 dark:text-gray-400 m-0 mt-0.5">
              {t(
                "Products.Table.aiGenerated.subtitle",
                "صفحات الهبوط التي أنشأها FoorAi لمتجرك",
              )}
            </p>
          </div>
        </div>

        <div className="relative w-full sm:w-80">
          <Search
            size={16}
            className={`absolute top-1/2 -translate-y-1/2 text-gray-400 ${
              i18n.language === "ar" ? "end-3" : "start-3"
            }`}
          />
          <input
            type="text"
            value={filter}
            onChange={(e) => setFilter(e.target.value)}
            placeholder={t("Products.Table.aiGenerated.searchPlaceholder")}
            className="w-full border border-gray-200 dark:!border-[#3c3a3d] dark:!bg-[#1e1e1e] dark:text-gray-200 rounded-lg ps-9 pe-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-[#9b59bf]"
          />
          {filter && (
            <button
              type="button"
              onClick={() => setFilter("")}
              className="absolute top-1/2 -translate-y-1/2 end-2.5 p-1 rounded-md text-gray-400 hover:text-gray-600 hover:bg-gray-100 dark:hover:bg-[#2a2a2c]"
            >
              <X size={14} />
            </button>
          )}
        </div>
      </div>

      <DataTableTemplatingDemo
        setLgShow={setLgShow}
        setData={setData}
        filter={filter}
        filter2="ai_generated"
        pageSize={pageSize}
      />
    </div>
  );
};

export default AiGeneratedProductsTable;
